// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import '@/icons' // icon
import 'vux/src/styles/reset.less'
import 'vux/src/styles/close.less'
import './assets/iconfont/iconfont.css'
// import $ from 'jquery'
import '../static/bootstrap/css/bootstrap.min.css';
import '../static/bootstrap/js/bootstrap.min.js';

import './assets/style/index.styl'

Vue.config.productionTip = false
// Vue.use(Vuex)
Vue.config.devtools = true


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  // template: '<App/>'
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js